import { FixaSkeleton } from "@coworker/apprestructured/src/shared/wrappers/FixaSkeleton/FixaSkeleton";

function LoadingCardFragments() {
  return <FixaSkeleton width="100%" height="46.5px" />;
}

export default LoadingCardFragments;
